import React from "react";
import ConsolidatedSettlementSummaryTable from "./ConsolidatedSettlementSummaryTable";

const ConsolidatedSettlementSummaryList = () => {
  return (
    <div className="row m-0">
      <div className="col-12">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title">Consolidated Settlement Summary</h4>
            <p className="card-subtitle mb-4">
              Consolidated payments and refunds for the selected date range.
            </p>
            <ConsolidatedSettlementSummaryTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsolidatedSettlementSummaryList;
